import { SET_CONFIG, SET_USER } from '../action-types/authActionTypes';

const initialState = {
  config: null,
  user: null,
};

function authReducer(state = initialState, action) {
  switch (action.type) {
    case SET_CONFIG:
      return {
        ...state,
        config: action.payload,
      };
    case SET_USER:
      return {
        ...state,
        user: action.payload,
      };
    default:
      return state;
  }
}

export default authReducer;
